export default __webpack_public_path__ + "davannis_logo.png";